import React, { useState } from 'react'
import { motion } from "framer-motion";
import { getImages } from '../Components/Common/const'
import { Link } from 'react-router-dom';

const Transportation = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });

    const handleMouseMove = (e) => {
        const { clientX, clientY, currentTarget } = e;
        const { left, top, width, height } = currentTarget.getBoundingClientRect();

        // Calculate relative position (-50 to 50 range)
        const x = ((clientX - left) / width - 2) * 20; // Text movement
        const y = ((clientY - top) / height - 1) * 20;

        const bgX = ((clientX - left) / width - 5) * 30; // Background movement
        const bgY = ((clientY - top) / height - 0.5) * 30;

        setPosition({ x, y, bgX, bgY });
    };
  return (
    <>
        <section className='common-wrap d-flex align-items-center transportation-banner-wrap' style={{ backgroundImage: `url(${getImages('transportation-hero-bg.webp')})` }}>
            <div className='w-100'>
                <div className='container'>
                    <h1 className='xl-title text-uppercase text-center wow reveal fadeInUp'>Transportation</h1>
                    <h2 className='lg-title text-uppercase text-center fw-500 mt-3 mb-3 wow reveal fadeInUp'>Vehicle Delivery & Transportation Services</h2>
                </div>
            </div>
        </section>
        <section className='drive-home-wrap d-lg-flex align-items-center'>
            <div className='w-50'>
                <div className='mxw-580 pe-md-5 mx-auto'>
                    <h3 className='lg-title text-uppercase mb-3'>Nationwide Delivery</h3>
                    <div className="common-text">
                        <p>We are diligent when handling your transportation needs.  We only arrange shipments with licensed, bonded and insured companies with proven track records. This will ensure your car will be delivered in the same condition it was in when leaving our South Florida Showroom.  Whether you require open or enclosed shipping across the state, the country or across the world, our staff is qualified to handle all aspects of transporting your new purchase to you quickly and safely.</p>
                    </div>
                </div>
            </div>
            <div className='w-50'>
                <img className='w-100' src={getImages('nationwide-delivery-image.webp')}/>
            </div>
        </section>
        
        <section className='top-appraisal-wrap vehicle-delivery-wrap'>
            <div className="mouse-container" onMouseMove={handleMouseMove}>
                {/* Background Move Effect */}
                <motion.div
                    className="mouse-background"
                    animate={{
                        x: position.bgX,
                        y: position.bgY,
                    }}
                    transition={{ type: "tween", stiffness: 50 }}
                />
                
                <div className='w-100 text-center mouse-text'>
                    
                    <h4 className='xl-title text-uppercase text-center wow reveal fadeInUp'>Vehicle Delivery</h4>
                    <div className='lg-title text-uppercase text-center fw-500 mt-4 wow reveal fadeInUp'>Bringing Your Dream Car to Your Doorstep—Anywhere, Anytime</div>
                    <div className='text-center mt-md-5 mt-4 wow reveal fadeInUp'>
                        <Link to="/contact-us" className='black-btn get-started-btn w-240 text-uppercase'>Get Started</Link>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Transportation